import * as PropTypes from 'prop-types';
import * as React from 'react';
import StandaloneAjaxAddToCartButton from '../listings/cart/standalone_ajax_add_to_cart_button';
import Upsells from './upsells';

const SidebarUpsells = props => (
  <Upsells
    listingId={props.listingId}
    children={props.children}
    aid="related_content_upsells_product_show_page"
    addToCartButton={StandaloneAjaxAddToCartButton}
    renderForSidebar
  />
);

SidebarUpsells.propTypes = {
  listingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default SidebarUpsells;



// WEBPACK FOOTER //
// ./javascripts/components/product_show_page/sidebar_upsells.jsx